import * as React from "react";
const SvgXcircleG700 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <circle cx={9} cy={9} r={9} fill="#DEDEDE" />
    <path stroke="#505050" strokeLinecap="round" strokeLinejoin="round" d="m6 12 6-6M12 12 6 6" />
  </svg>
);
export default SvgXcircleG700;
